import React from 'react';
import { MobileMenuButton } from './MobileMenuButton';
import { BrandBlock } from './BrandBlock';
import { AppSwitcher } from './AppSwitcher';
import { ActiveAppLabel } from './ActiveAppLabel';
import { GlobalSearch } from './GlobalSearch';
import { RoleViewSwitcher } from './RoleViewSwitcher';
import { ThemeToggle } from './ThemeToggle';
import { TopbarSubrow } from './TopbarSubrow';
import { UserMenu } from './UserMenu';
import { ChildSwitcher } from './ChildSwitcher';
import { MobilePageTitle } from '../mobile/MobilePageTitle';

export const Topbar: React.FC = () => {
  return (
    <header
      data-shell-header
      className="w-full shrink-0 sticky top-0 z-40 bg-navbar text-navbar-foreground border-b border-navbar-border shadow-xs pt-[var(--safe-top)]"
    >
      <div className="h-12 px-3 flex items-center justify-between gap-2 w-full md:border-b md:border-navbar-border">
        <div className="flex items-center gap-2 min-w-0">
          <MobileMenuButton />
          <div className="md:hidden flex items-center gap-1.5 min-w-0">
            <MobilePageTitle />
            <ChildSwitcher />
          </div>
          <div className="hidden md:flex items-center gap-2 min-w-0">
            <BrandBlock />
            <span className="h-4 w-px bg-navbar-border mx-1 shrink-0" aria-hidden />
            <AppSwitcher />
            <ActiveAppLabel />
            <ChildSwitcher />
          </div>
        </div>

        <div className="flex items-center gap-1.5 shrink-0">
          <div className="hidden md:flex items-center gap-1.5">
            <RoleViewSwitcher />
          </div>
          <GlobalSearch />
          <div className="hidden md:flex items-center">
            <ThemeToggle />
            <span className="h-4 w-px bg-navbar-border mx-1 shrink-0" aria-hidden />
          </div>
          <UserMenu />
        </div>
      </div>
      <TopbarSubrow />
    </header>
  );
};
